import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

/*
  CR U11 — "Ad Segment" management tool.
  Lets an admin create named groups (e.g. "Kathmandu campaign",
  "Retargeting - abandoned enquiry") that leads can be tagged into from
  the Ad-Leads screen, for later follow-up/export.
*/
export default function AdminAdSegments() {
    const [segments, setSegments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState(null);

    const load = () => {
        setLoading(true);
        adminFetch(`${API_BASE}/api/get_ad_segments.php`)
            .then((r) => r.json())
            .then((data) => { if (data.success) setSegments(data.segments); })
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!name.trim()) return;
        setSaving(true);
        setMsg(null);
        try {
            const res = await adminFetch(`${API_BASE}/api/save_ad_segment.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ name: name.trim(), description: description.trim() }),
            });
            const data = await res.json();
            setSaving(false);
            if (data.success) {
                setName("");
                setDescription("");
                load();
            } else {
                setMsg({ type: "danger", text: data.message || "Could not save." });
            }
        } catch {
            setSaving(false);
            setMsg({ type: "danger", text: "Network error." });
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this segment? Leads tagged with it will become untagged.")) return;
        const res = await adminFetch(`${API_BASE}/api/delete_ad_segment.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id }),
        });
        const data = await res.json();
        if (data.success) load();
        else setMsg({ type: "danger", text: data.message || "Could not delete." });
    };

    return (
        <div>
            <h5 className="fw-bold mb-1">Ad Segments</h5>
            <p className="text-secondary small mb-3">
                Named groups you can tag leads into from the Ad-Leads screen — useful for organizing follow-up by campaign or source.
            </p>

            {msg && <div className={`alert alert-${msg.type} py-2`}>{msg.text}</div>}

            <form className="card shadow-sm mb-3" onSubmit={handleCreate}>
                <div className="card-body">
                    <div className="row g-2 align-items-end">
                        <div className="col-md-4">
                            <label className="form-label small">Segment Name</label>
                            <input className="form-control form-control-sm" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Kathmandu Campaign" required />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small">Description (optional)</label>
                            <input className="form-control form-control-sm" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="What this segment is for" />
                        </div>
                        <div className="col-md-2">
                            <button className="btn btn-primary btn-sm w-100" type="submit" disabled={saving}>{saving ? "Adding..." : "+ Add Segment"}</button>
                        </div>
                    </div>
                </div>
            </form>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : segments.length === 0 ? (
                        <div className="p-3 text-secondary">No segments yet — create one above.</div>
                    ) : (
                        <table className="table table-sm mb-0">
                            <thead className="table-light">
                                <tr><th>Name</th><th>Description</th><th>Leads</th><th></th></tr>
                            </thead>
                            <tbody>
                                {segments.map((s) => (
                                    <tr key={s.id}>
                                        <td className="fw-semibold">{s.name}</td>
                                        <td className="text-secondary small">{s.description || "—"}</td>
                                        <td>{s.lead_count}</td>
                                        <td className="text-end">
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(s.id)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
